import type {Palette} from '../types';
import {PALETTE_ID} from '../types';

export default {
    id: PALETTE_ID.CLASSIC_20,
    scheme: [
        '#4DA2F1',
        '#FF3D64',
        '#8AD554',
        '#FFC636',
        '#FFB9DD',
        '#84D1EE',
        '#FF91A1',
        '#54A520',
        '#DB9100',
        '#BA74B3',
        '#1F68A9',
        '#ED65A9',
        '#0FA08D',
        '#FF7E00',
        '#E8B0A4',
        '#52A6C5',
        '#BE2443',
        '#70C1AF',
        '#FFB46C',
        '#DCA3D7',
    ],
    datalens: true,
} as Palette;
